import { useSelector } from "react-redux";
import { currencyConversion } from "../../../utils/utilityFunctions";
import { RootStateType } from "../../../redux-store/reducers";
import {
    Box,
    Theme,
    Typography
} from "@mui/material";
import { BlackInfo } from "../../../assets/SvgIcons";

export function CurrencyConversionToWords({
    value
}: {
    value: string
}): JSX.Element {
    const { locale } = useSelector((store: RootStateType) => store.currencyInfo);

    return (
        <>
            {currencyConversion(locale, value === "0" ? value : Number(value)) && (
                <Box
                    sx={{
                        display: 'flex',
                        gap: '5px',
                        alignItems: 'center',
                        marginTop: "-5px"
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            flexShrink: 0
                        }}
                    >
                        <BlackInfo />
                    </Box>
                    <Typography
                        variant="overline_400"
                        sx={(theme: Theme) => ({
                            lineHeight: "17.5px",
                            letterSpacing: "0.02px",
                            color: theme.palette.text.secondary
                        })}
                    >
                        {currencyConversion(locale, value === "0" ? value : Number(value))}
                    </Typography>
                </Box>
            )}
        </>
    )
}